<template>
  <v-data-table
    v-model="selecteds"
    :headers="headers"
    :items="classes"
    item-key="title"
    show-select
    class="elevation-1"
    :footer-props="{
      'items-per-page-text': 'Số dòng mỗi trang',
      'items-per-page-all-text': 'Tất cả',
    }"
  >
    <template v-slot:[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} trên tổng
      {{ items.itemsLength }}
    </template>
    <template v-slot:[`item.studentNo`]="{ item }">
      {{ item.students.filter((s) => s.status === 'active').length }}
    </template>

    <div slot="top">
      <div>
        <div class="d-flex pa-6 justify-space-between">
          <AutocompleteGrade
            class="mr-2"
            v-model="grade"
            item-text="title"
            item-value="id"
            label="Học phần"
            required
            dense
            outlined
            auto-select-first
            hide-details
            style="max-width: 400px"
          />
          <v-btn class="search-button" color="primary" prepend-icon="mdi-magnify" outlined @click="search">Tìm kiếm</v-btn>
        </div>
        <div class="d-flex justify-space-between px-6 mb-6">
          <span :class="selecteds.length ? 'text--primary mt-2' : 'text--disabled mt-2'">
            {{ selecteds.length ? 'Đã chọn ' + selecteds.length + ' lớp' : 'Chưa chọn' }}
          </span>
          <v-btn
            outlined
            color="primary"
            :disabled="!selecteds.length"
            @click="$emit('sendPost', { classes: selecteds })"
          >
            Gửi tin nhắn
          </v-btn>
        </div>
      </div>
    </div>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import get from 'lodash-es/get'

export default {
  components: { AutocompleteGrade },
  data() {
    return {
      selecteds: [],
      grade: null,
      headers: [
        { text: 'Nhóm nhận tin', value: 'title' },
        // { text: 'Số lớp', value: 'classNo' },
        { text: 'Số học viên', value: 'studentNo' },
      ],
    }
  },
  computed: {
    ...mapState('postCreate', ['classes', 'sendPostResult']),
  },
  methods: {
    ...mapActions('postCreate', ['fetchClassData']),
    search() {
      if (this.grade) {
        this.fetchClassData({ grade: get(this.grade, 'id') })
      }
    },
  },
  watch: {
    sendPostResult: {
      handler(val) {
        if (val && val.isSuccess) {
          this.selecteds = []
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
